import { render, staticRenderFns } from "./KCheckbox.vue?vue&type=template&id=69815c28&scoped=true&"
import script from "./KCheckbox.vue?vue&type=script&lang=js&"
export * from "./KCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./KCheckbox.vue?vue&type=style&index=0&id=69815c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69815c28",
  null
  
)

export default component.exports